import * as React from 'react'
import { observer } from 'mobx-react'
import SelectionViewModel from '../SelectionViewModel'
import {
  Dialog,
  DialogTitle,
  DialogDescription,
  DialogHeader,
  DialogContent,
  DialogFooter,
  DialogButton,
} from 'components/Dialog'

interface SelectionEditorDialogProps<T> {
  title: React.ReactNode
  description: React.ReactNode
  selectionVM: SelectionViewModel<T>
  /**
   * Should be the SelectionList.
   */
  children?: React.ReactNode
}

export default observer(function SelectionEditorDialog<T>({
  selectionVM,
  title,
  children,
  description,
}: SelectionEditorDialogProps<T>) {
  return (
    <Dialog
      showing={selectionVM.showingEditor.isEnabled}
      onClose={selectionVM.showingEditor.disable}
    >
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
      </DialogHeader>
      <DialogContent>{children}</DialogContent>
      <DialogFooter bordered>
        <DialogButton onClick={selectionVM.showingEditor.disable}>
          Close
        </DialogButton>
      </DialogFooter>
    </Dialog>
  )
})
